import Phaser from 'phaser';
import { CROPS } from '../data/crops';
import type { WorldScene } from './WorldScene';

/** Debug overlay: time skip, money, items, energy, teleport, FPS/draw readout.
 *  Opened via ?debug=1 or a touch-accessible 5-tap on the top-left corner. */
export class DebugScene extends Phaser.Scene {
  private fpsText!: Phaser.GameObjects.Text;

  constructor() {
    super('Debug');
  }

  create(): void {
    const x = 10;
    const top = 72;
    let y = top;
    const panelW = 184;
    const rows = 7;

    const g = this.add.graphics().setDepth(2000);
    g.fillStyle(0x10131a, 0.82);
    g.fillRoundedRect(x - 6, top - 30, panelW, rows * 30 + 40, 8);
    g.lineStyle(1, 0x3a4250, 1);
    g.strokeRoundedRect(x - 6, top - 30, panelW, rows * 30 + 40, 8);

    this.add
      .text(x, top - 26, 'DEBUG', { fontFamily: 'monospace', fontSize: '12px', color: '#7dbf5a' })
      .setDepth(2001)
      .setResolution(2);
    this.fpsText = this.add
      .text(x + 56, top - 26, '', { fontFamily: 'monospace', fontSize: '11px', color: '#cfd6e0' })
      .setDepth(2001)
      .setResolution(2);

    const world = (): WorldScene => this.scene.get('World') as WorldScene;
    const add = (label: string, cb: () => void): void => {
      this.makeButton(x, y, panelW - 8, label, cb);
      y += 30;
    };

    add('+1 hour', () => world().dbgAddMinutes(60));
    add('+1 day (sleep)', () => world().dbgSleep());
    add('+100 gold', () => world().dbgAddMoney(100));
    add('give 5 of each seed', () => {
      for (const c of Object.values(CROPS)) world().dbgGiveItem(c.seedItemId, 5);
    });
    add('refill energy', () => world().dbgRefillEnergy());
    add('teleport (tap map)', () => {
      world().dbgTeleportMode();
      this.scene.stop();
    });
    add('close', () => this.scene.stop());
  }

  private makeButton(x: number, y: number, w: number, label: string, cb: () => void): void {
    const g = this.add.graphics().setDepth(2001);
    g.fillStyle(0x2a3340, 1);
    g.fillRoundedRect(x, y, w, 26, 5);
    this.add
      .text(x + 8, y + 6, label, { fontFamily: 'monospace', fontSize: '12px', color: '#e6ebf2' })
      .setDepth(2002)
      .setResolution(2);
    const hit = this.add
      .rectangle(x, y, w, 26, 0xffffff, 0)
      .setOrigin(0, 0)
      .setDepth(2002)
      .setInteractive({ useHandCursor: true });
    hit.on('pointerup', cb);
  }

  update(): void {
    const world = this.scene.get('World');
    const objs = world ? world.children.list.length : 0;
    const r = this.game.renderer as unknown as { drawCount?: number };
    const draws = typeof r.drawCount === 'number' ? r.drawCount : objs;
    this.fpsText.setText(`${Math.round(this.game.loop.actualFps)}fps  ${draws}d`);
  }
}
